import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [permisos, setPermisos] = useState([]);
  const [menuActual, setMenuActual] = useState(null);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState(0);
  const [isExandMenu, setIsExpandMenu] = useState(false);

  //CATALOGOS GLOBAL
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [codigos, setCodigos] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [referenceTypes,setReferenceTypes] = useState([])
  const [clientActual,setClientActual] = useState(null);
  const [communications,setCommunications] = useState([]);


  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const handleLogout = () => {
    setEstados([]);
    setMunicipios([]);
    setCodigos([]);
    setMenuActual(null);
    setToken(null)
};
  return (
    <AuthContext.Provider value={{ userId, setUserId,token, setToken, permisos, setPermisos, menuActual, setMenuActual, userName, setUserName, windowSize, setWindowSize, isExandMenu, setIsExpandMenu,estados, setEstados,municipios, setMunicipios,codigos, setCodigos,documentTypes, setDocumentTypes,referenceTypes,setReferenceTypes,clientActual,setClientActual,communications,setCommunications,handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook personalizado para usar el contexto
export const useAuth = () => {
  return useContext(AuthContext);
};
